import { z } from 'zod';
import { LIMITS } from '../limits.js';

/**
 * Vault shelves ("полки") — user-named collections inside the personal Сейф.
 * Shelves behave as TAGS: one saved item (a vault message) can sit on several
 * shelves at once. All shelf data is private to the owner.
 */
export const createShelfSchema = z.object({
  name: z.string().trim().min(1).max(LIMITS.vaultShelf.nameMax),
});
export type CreateShelfInput = z.infer<typeof createShelfSchema>;

export const renameShelfSchema = createShelfSchema;
export type RenameShelfInput = z.infer<typeof renameShelfSchema>;

/** Replace the full set of shelves a given vault message is filed under. */
export const setMessageShelvesSchema = z.object({
  shelfIds: z.array(z.string().cuid()).max(LIMITS.vaultShelf.perMessage),
});
export type SetMessageShelvesInput = z.infer<typeof setMessageShelvesSchema>;
